"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonsterClass = exports.Holiday = exports.Currency = exports.LearnedSpell = exports.FOVVisibility = exports.Hostility = exports.SkillDisplayName = exports.Tradeskill = exports.Skill = exports.Stat = exports.FestivalStat = exports.ItemSlot = exports.BaseClass = exports.DamageClass = exports.Alignment = exports.Allegiance = void 0;
var Allegiance;
(function (Allegiance) {
    // for things that do not have an allegiance
    Allegiance["None"] = "None";
    Allegiance["Adventurers"] = "Adventurers";
    Allegiance["Pirates"] = "Pirates";
    Allegiance["Royalty"] = "Royalty";
    Allegiance["Townsfolk"] = "Townsfolk";
    Allegiance["Underground"] = "Underground";
    Allegiance["Wilderness"] = "Wilderness";
    // for enemies, will always be hostile to everything
    Allegiance["Enemy"] = "Enemy";
    // for natural resources
    Allegiance["NaturalResource"] = "NaturalResource";
    // for GMs
    Allegiance["GM"] = "GM";
})(Allegiance || (exports.Allegiance = Allegiance = {}));
var Alignment;
(function (Alignment) {
    Alignment["Good"] = "good";
    Alignment["Neutral"] = "neutral";
    Alignment["Evil"] = "evil";
})(Alignment || (exports.Alignment = Alignment = {}));
var DamageClass;
(function (DamageClass) {
    DamageClass["Physical"] = "physical";
    DamageClass["Necrotic"] = "necrotic";
    DamageClass["Energy"] = "energy";
    DamageClass["Disease"] = "disease";
    DamageClass["Poison"] = "poison";
    DamageClass["Sonic"] = "sonic";
    DamageClass["Water"] = "water";
    DamageClass["Fire"] = "fire";
    DamageClass["Ice"] = "ice";
    DamageClass["Lightning"] = "lightning";
    DamageClass["Acid"] = "acid";
    // used for healing damage
    DamageClass["Heal"] = "heal";
    // used for cheese damage
    DamageClass["GM"] = "gm";
    // used specifically for guns hunting turkeys
    DamageClass["Turkey"] = "turkey";
    // different classes of weapons
    DamageClass["Sharp"] = "sharp";
    DamageClass["Blunt"] = "blunt";
})(DamageClass || (exports.DamageClass = DamageClass = {}));
var BaseClass;
(function (BaseClass) {
    BaseClass["Traveller"] = "Traveller";
    BaseClass["Mage"] = "Mage";
    BaseClass["Thief"] = "Thief";
    BaseClass["Healer"] = "Healer";
    BaseClass["Warrior"] = "Warrior";
    BaseClass["Arcanist"] = "Arcanist";
    BaseClass["Barbarian"] = "Barbarian";
})(BaseClass || (exports.BaseClass = BaseClass = {}));
var ItemSlot;
(function (ItemSlot) {
    ItemSlot["Head"] = "head";
    ItemSlot["Neck"] = "neck";
    ItemSlot["Ear"] = "ear";
    ItemSlot["Waist"] = "waist";
    ItemSlot["Wrists"] = "wrists";
    ItemSlot["Ring"] = "ring";
    ItemSlot["Ring1"] = "ring1";
    ItemSlot["Ring2"] = "ring2";
    ItemSlot["Hands"] = "hands";
    ItemSlot["Feet"] = "feet";
    ItemSlot["Armor"] = "armor";
    ItemSlot["Robe"] = "robe";
    ItemSlot["Robe1"] = "robe1";
    ItemSlot["Robe2"] = "robe2";
    ItemSlot["RightHand"] = "rightHand";
    ItemSlot["LeftHand"] = "leftHand";
    ItemSlot["Trinket"] = "trinket";
    ItemSlot["Potion"] = "potion";
    ItemSlot["Ammo"] = "ammo";
})(ItemSlot || (exports.ItemSlot = ItemSlot = {}));
var FestivalStat;
(function (FestivalStat) {
    FestivalStat["SpawnTickMultiplierBoost"] = "spawnTickMultiplierBoost";
})(FestivalStat || (exports.FestivalStat = FestivalStat = {}));
var Stat;
(function (Stat) {
    // core
    Stat["STR"] = "str";
    Stat["DEX"] = "dex";
    Stat["AGI"] = "agi";
    Stat["INT"] = "int";
    Stat["WIS"] = "wis";
    Stat["WIL"] = "wil";
    Stat["CHA"] = "cha";
    Stat["LUK"] = "luk";
    Stat["CON"] = "con";
    Stat["HP"] = "hp";
    Stat["MP"] = "mp";
    Stat["HPRegen"] = "hpregen";
    Stat["MPRegen"] = "mpregen";
    // extra stats
    Stat["WeaponDamageRolls"] = "weaponDamageRolls";
    Stat["WeaponArmorClass"] = "weaponArmorClass";
    Stat["ArmorClass"] = "armorClass";
    Stat["Accuracy"] = "accuracy";
    Stat["Offense"] = "offense";
    Stat["Defense"] = "defense";
    // stealth stats
    Stat["Stealth"] = "stealth";
    Stat["Perception"] = "perception";
    // boost stats
    Stat["PhysicalBoostPercent"] = "physicalDamageBoostPercent";
    Stat["MagicalBoostPercent"] = "magicalDamageBoostPercent";
    Stat["HealingBoostPercent"] = "healingBoostPercent";
    // smaller boost stats
    Stat["NecroticBoostPercent"] = "necroticBoostPercent";
    Stat["EnergyBoostPercent"] = "energyBoostPercent";
    Stat["DiseaseBoostPercent"] = "diseaseBoostPercent";
    Stat["PoisonBoostPercent"] = "poisonBoostPercent";
    Stat["SonicBoostPercent"] = "sonicBoostPercent";
    Stat["WaterBoostPercent"] = "waterBoostPercent";
    Stat["FireBoostPercent"] = "fireBoostPercent";
    Stat["IceBoostPercent"] = "iceBoostPercent";
    Stat["LightningBoostPercent"] = "lightningBoostPercent";
    Stat["AcidBoostPercent"] = "acidBoostPercent";
    // reflect stats
    Stat["PhysicalReflect"] = "physicalDamageReflect";
    Stat["MagicalReflect"] = "magicalDamageReflect";
    Stat["SpellReflectChance"] = "spellReflectChance";
    // resist stats
    Stat["Mitigation"] = "mitigation";
    Stat["MagicalResist"] = "magicalResist";
    Stat["PhysicalResist"] = "physicalResist";
    Stat["NecroticResist"] = "necroticResist";
    Stat["EnergyResist"] = "energyResist";
    Stat["DiseaseResist"] = "diseaseResist";
    Stat["PoisonResist"] = "poisonResist";
    Stat["SonicResist"] = "sonicResist";
    Stat["WaterResist"] = "waterResist";
    Stat["FireResist"] = "fireResist";
    Stat["IceResist"] = "iceResist";
    Stat["LightningResist"] = "lightningResist";
    Stat["AcidResist"] = "acidResist";
    // uncommon
    Stat["Move"] = "move";
    Stat["ActionSpeed"] = "actionSpeed";
    Stat["ThreatMultiplier"] = "threatMultiplier";
    Stat["DamageFactor"] = "damageFactor";
    Stat["XPBonusPercent"] = "xpBonusPercent";
    Stat["SkillBonusPercent"] = "skillBonusPercent";
    Stat["SpellCriticalPercent"] = "spellCriticalPercent";
    Stat["SavingThrow"] = "savingThrow";
    // skill bonuses
    Stat["MaceBonus"] = "maceBonus";
    Stat["AxeBonus"] = "axeBonus";
    Stat["DaggerBonus"] = "daggerBonus";
    Stat["SwordBonus"] = "swordBonus";
    Stat["ShortswordBonus"] = "shortswordBonus";
    Stat["PolearmBonus"] = "polearmBonus";
    Stat["WandBonus"] = "wandBonus";
    Stat["StaffBonus"] = "staffBonus";
    Stat["MartialBonus"] = "martialBonus";
    Stat["RangedBonus"] = "rangedBonus";
    Stat["ThrowingBonus"] = "throwingBonus";
    Stat["TwoHandedBonus"] = "twohandedBonus";
    Stat["ThieveryBonus"] = "thieveryBonus";
    Stat["ConjurationBonus"] = "conjurationBonus";
    Stat["RestorationBonus"] = "restorationBonus";
})(Stat || (exports.Stat = Stat = {}));
var Skill;
(function (Skill) {
    Skill["Mace"] = "mace";
    Skill["Axe"] = "axe";
    Skill["Dagger"] = "dagger";
    Skill["Sword"] = "sword";
    Skill["Shortsword"] = "shortsword";
    Skill["Polearm"] = "polearm";
    Skill["Wand"] = "wand";
    Skill["Staff"] = "staff";
    Skill["Martial"] = "martial";
    Skill["Ranged"] = "ranged";
    Skill["Throwing"] = "throwing";
    Skill["TwoHanded"] = "twohanded";
    Skill["Thievery"] = "thievery";
    Skill["Conjuration"] = "conjuration";
    Skill["Restoration"] = "restoration";
})(Skill || (exports.Skill = Skill = {}));
var Tradeskill;
(function (Tradeskill) {
    Tradeskill["Alchemy"] = "alchemy";
    Tradeskill["Spellforging"] = "spellforging";
    Tradeskill["Metalworking"] = "metalworking";
    Tradeskill["Gemcrafting"] = "gemcrafting";
    Tradeskill["Weavefabricating"] = "weavefabricating";
    Tradeskill["Foodmaking"] = "foodmaking";
})(Tradeskill || (exports.Tradeskill = Tradeskill = {}));
var SkillDisplayName;
(function (SkillDisplayName) {
    // base item classes
    SkillDisplayName["Mace"] = "Maces";
    SkillDisplayName["Axe"] = "Axes";
    SkillDisplayName["Dagger"] = "Daggers";
    SkillDisplayName["Sword"] = "Longswords";
    SkillDisplayName["Shortsword"] = "Shortswords";
    SkillDisplayName["Polearm"] = "Polearms";
    SkillDisplayName["Wand"] = "Magical Weapons";
    SkillDisplayName["Staff"] = "Staves";
    // special item classes
    SkillDisplayName["Martial"] = "Martial Arts";
    SkillDisplayName["Ranged"] = "Ranged Weapons";
    SkillDisplayName["Throwing"] = "Throwing Weapons";
    SkillDisplayName["TwoHanded"] = "Two-handed Weapons";
    SkillDisplayName["Thievery"] = "Thievery";
    SkillDisplayName["Conjuration"] = "Conjuration Magic";
    SkillDisplayName["Restoration"] = "Restoration Magic";
    // tradeskills
    SkillDisplayName["Alchemy"] = "Alchemy";
    SkillDisplayName["Spellforging"] = "Spellforging";
    SkillDisplayName["Runewriting"] = "Runewriting";
    SkillDisplayName["Metalworking"] = "Metalworking";
    SkillDisplayName["Gemcrafting"] = "Gemcrafting";
    SkillDisplayName["Weavefabricating"] = "Weavefabricating";
    SkillDisplayName["Foodmaking"] = "Foodmaking";
    SkillDisplayName["Survival"] = "survival";
})(SkillDisplayName || (exports.SkillDisplayName = SkillDisplayName = {}));
var Hostility;
(function (Hostility) {
    Hostility["Never"] = "Never";
    Hostility["OnHit"] = "OnHit";
    Hostility["Faction"] = "Faction";
    Hostility["Always"] = "Always";
})(Hostility || (exports.Hostility = Hostility = {}));
var FOVVisibility;
(function (FOVVisibility) {
    FOVVisibility[FOVVisibility["CantSee"] = 0] = "CantSee";
    FOVVisibility[FOVVisibility["CanSee"] = 1] = "CanSee";
    FOVVisibility[FOVVisibility["CanSeeButDark"] = 2] = "CanSeeButDark";
})(FOVVisibility || (exports.FOVVisibility = FOVVisibility = {}));
var LearnedSpell;
(function (LearnedSpell) {
    LearnedSpell[LearnedSpell["FromFate"] = -2] = "FromFate";
    LearnedSpell[LearnedSpell["FromItem"] = -1] = "FromItem";
    LearnedSpell[LearnedSpell["Unlearned"] = 0] = "Unlearned";
    LearnedSpell[LearnedSpell["FromTraits"] = 1] = "FromTraits";
})(LearnedSpell || (exports.LearnedSpell = LearnedSpell = {}));
var Currency;
(function (Currency) {
    Currency["January"] = "confetti coins";
    Currency["February"] = "heart coins";
    Currency["March"] = "spring coins";
    Currency["April"] = "rain coins";
    Currency["May"] = "flower coins";
    Currency["June"] = "celebration coins";
    Currency["July"] = "fireworks coins";
    Currency["August"] = "leaf coins";
    Currency["September"] = "school coins";
    Currency["Halloween"] = "pumpkin coins";
    Currency["Thanksgiving"] = "turkey coins";
    Currency["Christmas"] = "snowflake coins";
    Currency["Fate"] = "threads of fate";
    Currency["Silver"] = "silver";
    Currency["Gold"] = "gold";
})(Currency || (exports.Currency = Currency = {}));
var Holiday;
(function (Holiday) {
    Holiday["Halloween"] = "Halloween";
    Holiday["Thanksgiving"] = "Thanksgiving";
    Holiday["Christmas"] = "Christmas";
})(Holiday || (exports.Holiday = Holiday = {}));
var MonsterClass;
(function (MonsterClass) {
    MonsterClass["Beast"] = "Beast";
    MonsterClass["Dragon"] = "Dragon";
    MonsterClass["Humanoid"] = "Humanoid";
    MonsterClass["Undead"] = "Undead";
    MonsterClass["Rock"] = "Rock";
    MonsterClass["Plant"] = "Plant";
    MonsterClass["Insect"] = "Insect";
    MonsterClass["Elemental"] = "Elemental";
})(MonsterClass || (exports.MonsterClass = MonsterClass = {}));
